import classnames from 'classnames';
import React from 'react';
import { Alert as RbAlert } from 'react-bootstrap';
import { Variant } from 'react-bootstrap/esm/types';
import useDynamicReactIcon from 'v2/hooks/useDynamicReactIcon';
import { getIconColorBySeverity } from 'v2/utils/iconUtils';

interface AlertProps {
  severity: Variant;
  title?: string;
  content?: string;
  icon?: string;
  className?: string;
}

const NomadAlert = ({
  icon,
  severity,
  title,
  content,
  className,
}: AlertProps) => {
  const Icon = useDynamicReactIcon(icon || '');

  return (
    <RbAlert className={classnames('d-flex m-0', className)} variant={severity}>
      {Icon ? (
        <Icon
          className={classnames(
            'alert-icon mr-3 mt-1',
            getIconColorBySeverity(severity)
          )}
          size={22}
          aria-label={`nomadAlertIcon${icon}`}
        />
      ) : null}
      <div>
        {title ? <p className="title m-0">{title}</p> : null}
        {content ? <p className="mb-0">{content}</p> : null}
      </div>
    </RbAlert>
  );
};

export default NomadAlert;
